// extracted by mini-css-extract-plugin
export default {"genericCard":"No-z","inline":"Oo-z","mastercard":"Po-z","discover":"Qo-z","visa":"Ro-z","amex":"So-z","active":"To-z"};